import { useRouteContext } from './useRouteContext';

export const useTemplate = () => {
  const { routeData } = useRouteContext();
  const template = routeData?.route.template || routeData?.route.type || '';

  return {
    template,
    isNewsInsight: template === 'news-insight',
    isEvent: template === 'events',
    isNewsInsightsLanding: template === 'news-insights-landing',
  };
};
